import { useEffect, useState } from 'react';
import VideoEditor from './videoEditor';
import { EDITOR_VIDEO_OPEN } from '.';

const VideoInitialiser = () => {
  const [data, setData] = useState<OpenVideoEditorDataType>({} as OpenVideoEditorDataType);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const { eventName, data: eventData } = event.data;

      if (eventName === EDITOR_VIDEO_OPEN && eventData) {
        window.pendo.initialize({
          visitor: eventData.pendoUserData,
          account: eventData.pendoAccountData,
        });

        setData({
          originalUrl: eventData.originalUrl,
          sourceSets: eventData.sourceSets,
          originalMediaId: eventData.originalMediaId,
          fileName: eventData.fileName,
          serviceSet: eventData.serviceSet,
        });
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  if (!data.originalUrl) {
    return null;
  }

  if (data.originalUrl) {
    return (
      <VideoEditor
        originalMediaId={data.originalMediaId}
        originalUrl={data.originalUrl}
        sourceSets={data.sourceSets}
        resetState={() => {
          setData({} as OpenVideoEditorDataType);
        }}
        fileName={data.fileName}
        serviceSet={data.serviceSet}
      />
    );
  }

  return null;
};

export default VideoInitialiser;
